import { Box, Spinner, Text, VStack } from '@chakra-ui/react'

interface LoadingStateProps {
  message?: string
}

export function LoadingState({ message }: LoadingStateProps) {
  return (
    <Box textAlign="center" py={12}>
      <VStack gap={4}>
        <Spinner size="xl" color="brand.500" />
        {message && <Text color="gray.600">{message}</Text>}
      </VStack>
    </Box>
  )
}
